import React from 'react';
import { motion } from 'framer-motion';
export function Privacy() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen py-20" data-id="element-527" data-mp="2wjor7ww966s0">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-528" data-mp="3b9w31trr8rjq">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-529" data-mp="36hl1kmhd8xp2">
          Privacy Policy
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-530" data-mp="3k7okb3h1e99r">
          <p className="text-lg font-medium text-slate-900" data-id="element-531" data-mp="3f9mzoe3yq1w6">
            Effective Date: May 19, 2026
          </p>
          <p data-id="element-532" data-mp="3u5cr4rrx378a">
            At Daily Care Pharmacy, we are committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, and safeguard your
            personal information when you use our website and services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-533" data-mp="1uvcxo1kg45zc">
            Information We Collect
          </h2>
          <p data-id="element-534" data-mp="h3qwfssz4s5t">
            We collect information you provide directly to us, such as when you
            create an account, fill out a prescription refill request, or
            contact us for health consulting. This may include your name,
            contact information, and health-related data.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-535" data-mp="uuvoo9u0ii64">
            How We Use Your Information
          </h2>
          <p data-id="element-536" data-mp="zv09gc1ydz25">
            We use your information to provide and improve our pharmaceutical
            services, communicate with you about your prescriptions, and ensure
            compliance with legal and regulatory requirements.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-537" data-mp="1drdl34jt368p">
            Data Security
          </h2>
          <p data-id="element-538" data-mp="3am0ab7dvskjv">
            We implement industry-standard security measures to protect your
            data from unauthorized access, disclosure, or alteration. Your
            health information is handled with the highest level of
            confidentiality.
          </p>
        </div>
      </div>
    </motion.div>;
}